{
  "admins": {
    "errors": {
      "add": "فشل في إضافة المدير.",
      "notFound": "لم يتم العثور على هذا المدير."
    }
  },
  "home": {
    "goToSandbox": "الذهاب إلى ساحة التجريب",
    "subtitle": "هذا المستودع هو نقطة انطلاق لبناء تطبيقات الويب باستخدام React و shadcn-ui و TanStack Router.",
    "title": "مرحباً بك في قالب React من Mindsea."
  },
  "login": {
    "errors": {
      "invalidEmail": "يرجى إدخال عنوان بريد إلكتروني صحيح.",
      "unauthorized": "ليس لديك تصريح للوصول إلى هذا التطبيق."
    },
    "placeholder": "name@example.com",
    "sendCode": "إرسال الرمز",
    "subtitle": "أنشئ صفحة تسجيل الدخول هنا.",
    "title": "تسجيل الدخول"
  }
}
